__turbopack_context__.v({
  "card": "LoadingBucket-module-scss-module__qVKRka__card",
  "cardList": "LoadingBucket-module-scss-module__qVKRka__cardList",
  "eds-example-grid-coloring": "LoadingBucket-module-scss-module__qVKRka__eds-example-grid-coloring",
  "eds-example-grid-content": "LoadingBucket-module-scss-module__qVKRka__eds-example-grid-content",
  "eds-example-sidebar-content": "LoadingBucket-module-scss-module__qVKRka__eds-example-sidebar-content",
  "eds-g-cell": "LoadingBucket-module-scss-module__qVKRka__eds-g-cell",
  "eds-g-sidebar": "LoadingBucket-module-scss-module__qVKRka__eds-g-sidebar",
  "eds-g-view": "LoadingBucket-module-scss-module__qVKRka__eds-g-view",
  "root": "LoadingBucket-module-scss-module__qVKRka__root",
});
